module.exports = __webpack_public_path__ + "static/img/money-bag.3a14cc12.png";